import { EMPTY } from '../type_name'
export default {
    name: EMPTY,
    render(h) {
        return h('div')
    }
}